import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import NavDropdown from 'react-bootstrap/NavDropdown';

import Nav from 'react-bootstrap/Nav';


import PopupBox from '../PopupBox.js';


import Countdown from '../Countdown.js';




export default class Simple extends React.Component {
  render() {



    //handle the click on one of the buttons
    const handleClick = (e) => {

        //console.log("EVENT", e)

        //console.log(e.target.getAttribute("value"))

      //if the id value of the button and compare to the correct answer
      if( parseInt(e.target.getAttribute("value")) == 1)
      { 
        this.props.setResult(true, this)
      }
      else
      {
        this.props.setResult(false, this)
      }





    };


    var item_names = ["News", "Message Center", "Archive", "Offers", "Advice", "Danger", "Never click this", "Details", "Stats", "Guidance", "Knowledge base", "Subscriptions", "Edit", "Go", "Selection", "New", "Run", "Important", "My Account", "Help", "Extras", "Secret", "Don't Click Here", "My Profile", "My Info", "Personal Data", "Contact", "Privacy Settings", "Settings", "Options", "Secret Sauce", "About", "Documentation", "Advice", "Issues", "Contact Support", "Cookie data", "Newsletter data", "Chocolate Chips", "Close", "Request info", "More settings", "More Info", "Nothing here", "Stop", "Go back", "Help me", "Where Am I?"].sort(() => Math.random() - 0.5)
    
    //console.log("item_names.length", item_names.length)

    var main_menus = []


    var num_main_menus = this.props.m0;
    var num_top_menus = this.props.m1;
    var num_inner_menus = this.props.m2;
    var num_sub_items = this.props.m3;
    

    var total_sub_items = num_main_menus * num_top_menus * num_inner_menus * num_sub_items


    var opt_out_position = Math.floor(Math.random()*total_sub_items)

    var counter = 0;


    var counter_all = 0;

   

    for(var f = 0; f < num_main_menus; f ++)
        {


        var top_menus = []

        for(var k = 0; k < num_top_menus; k ++)
            {

                var inner_menus = []

                for(var i = 0; i < num_inner_menus; i ++)
                {

                    var sub_items = []

                    for(var j = 0; j < num_sub_items; j ++)
                    {
                        //console.log("opt_out_position", opt_out_position)
                        //console.log("counter", counter)
                        //console.log("-")

                        if(counter != opt_out_position)
                        {
                            //console.log("same")
                            sub_items.push(<NavDropdown.Item href="">{item_names.pop()}</NavDropdown.Item> )

                        }
                        else
                        {
                            sub_items.push(<NavDropdown.Item value={1} onClick={handleClick} href="">{this.props.correct_item}</NavDropdown.Item> )
                        }
                        

                        counter ++
                    }

                    inner_menus.push(
                        <NavDropdown title={item_names.pop()}>
                            {sub_items}
                        </NavDropdown>
                    )

                    counter_all ++;

                }

                top_menus.push(
                    <NavDropdown title={item_names.pop()}>
                        {inner_menus}
                    </NavDropdown>
                )

                counter_all ++;

            }


            main_menus.push(
                <NavDropdown className="nav-bordered" title={item_names.pop()}>
                    {top_menus}
                </NavDropdown>
            )

            counter_all ++;


        }

        //console.log("counter: ", counter_all + counter)

    return (




      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>



        <Countdown time_allowed={30} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>



        <Nav className="mr-auto">
            {main_menus}

        </Nav>

      
          <br></br><br></br>
     
        <h2 className="text-danger">{this.props.question.replace("_____", this.props.correct_item)}</h2>

       

      </PopupBox>

    );
  }
}



